import { Grid, LinearProgress, Step, StepLabel, Stepper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Confirmation from "./Components/Confirmation";
import EnterDetails from "./Components/EnterDetails";
import {
  cancel,
  clearErrors,
  currentPage,
  errors,
  getDropdownData,
  getPrepopDataAsync,
  isLoading,
  isKiosk,
  skipCaptcha,
} from "./features/AppSlice";
import { SARSHeader, ErrorModal, YoutubeEmbed } from "@soqs/common";
import React, { useEffect } from "react";
import Captcha from "./Components/Captcha";
import { getVideo } from "./features/API";

export const PAGES = {
  EnterDetails: 0,
  Captcha: 1,
  AssessmentResult: 2,
  Confirmation: 3,
};
function App() {
  const kiosktoken = new URLSearchParams(window.location.search).get("token");
  const dispatch = useDispatch();
  const pageState = useSelector(currentPage);
  const errorState = useSelector(errors);
  const loading = useSelector(isLoading);

  const kiosk = useSelector(isKiosk);
  const skipcaptcha = useSelector(skipCaptcha);

  useEffect(() => {
    dispatch(getDropdownData());
    if (kiosktoken) {
      dispatch(getPrepopDataAsync(kiosktoken));
    }
    return () => {};
  }, []);

  const Pager = ({ page }) => {
    switch (page) {
      case PAGES.EnterDetails:
        if (kiosktoken && loading) {
          return <LinearProgress />;
        }
        return <EnterDetails />;
      case PAGES.Captcha:
        return <Captcha />;
      case PAGES.AssessmentResult:
        return <EnterDetails />;
      case PAGES.Confirmation:
        return <Confirmation />;
      default: {
        dispatch(cancel());
      }
    }
  };

  const getStepFromPage = (page) => {
    switch (page) {
      case PAGES.EnterDetails:
        return 0;
      case PAGES.Captcha:
        return 1;
      case PAGES.AssessmentResult:
        if (kiosk && skipcaptcha) return 1;
        if (kiosk && !skipcaptcha) return 2;
        if (!kiosk) return 2;
        break;
      case PAGES.Confirmation:
        if (kiosk && skipcaptcha) return 2;
        if (kiosk && !skipcaptcha) return 3;
        if (!kiosk) return 3;
        break;
      default: {
        return 3;
      }
    }
  };

  const StepperWrapper = ({ page }) => (
    <Stepper activeStep={getStepFromPage(page)}>
      <Step key={PAGES.EnterDetails} completed={pageState > PAGES.EnterDetails}>
        <StepLabel>Enter Details</StepLabel>
      </Step>
      {!kiosk || !skipcaptcha ? (
        <Step key={PAGES.Captcha} completed={pageState > PAGES.Captcha}>
          <StepLabel>Captcha</StepLabel>
        </Step>
      ) : null}
      <Step
        key={PAGES.AssessmentResult}
        completed={pageState > PAGES.AssessmentResult}
      >
        <StepLabel>Result</StepLabel>
      </Step>
      <Step key={PAGES.Confirmation} completed={pageState > PAGES.Confirmation}>
        <StepLabel>Confirmation</StepLabel>
      </Step>
    </Stepper>
  );

  return (
    <>
      <SARSHeader
        onLogoClick={() => window.navigation.navigate(window.location)}
        pageTitle="Filing Season Auto Assessment Lookup"
        pageTitleWeb={"Filing Season Auto Assessment Lookup"}
        pageTitleMobile={"Assessment"}
      />
      <div className="App">
        <Grid
          container
          spacing={2}
          style={{
            minHeight: "80vh",
            paddingLeft: "2%",
            paddingRight: "2%",
            justifyContent: "center",
          }}
          alignContent="flex-start"
        >
          <Grid
            size={{ xs: 12 }}
            style={{ paddingTop: "8vh", maxWidth: "1500px" }}
          >
            <StepperWrapper page={pageState} />
          </Grid>
          <Grid
            size={{ xs: 12 }}
            style={{ paddingTop: "2vh", maxWidth: "1500px" }}
          >
            <Pager page={pageState} />
            <ErrorModal
              title={
                errorState?.errortitle
                  ? errorState?.errortitle
                  : typeof errorState?.error === "string" &&
                    errorState?.error?.indexOf("|") > -1
                  ? errorState?.error?.split("|")[0]
                  : "Error"
              }
              open={errorState !== null}
              onClose={() => {
                if (errorState?.fatal) {
                  dispatch(cancel());
                } else {
                  dispatch(clearErrors());
                }
              }}
              subheader={
                Array.isArray(errorState?.error) ? (
                  <ul>
                    {errorState?.error.map((e, idx) => (
                      <li key={idx}>{e.replace("- ", "")}</li>
                    ))}
                  </ul>
                ) : (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        errorState?.error?.indexOf("|") > -1
                          ? errorState?.error?.split("|")[1]
                          : errorState?.error,
                    }}
                  ></p>
                )
              }
            />
          </Grid>
        </Grid>
      </div>
      <YoutubeEmbed appCode="ALOOKUP" fetchVideo={getVideo} initialPosition="top-right"  />
    </>
  );
}

export default App;
